<template>
  <div class="log">
    <div class="login-container" ref="containerRef">
      <div class="card p-4" ref="cardRef">
        <div class="logo-container">
  <div>
    <div class="brand-title">MY EVENTO DIGITAL</div>
    <div class="brand-subtitle">Invitaciones Digitales</div>
  </div>
</div>
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="username" class="form-label">Usuario</label>
            <input
              id="username"
              v-model="username"
              type="text"
              class="form-control"
              required
              placeholder="Introduce tu usuario"
            >
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">Contraseña</label>
            <input
              id="password"
              v-model="password"
              type="password"
              class="form-control"
              required
              placeholder="Introduce tu contraseña"
            >
          </div>

          <button type="submit" class="btn btn-login w-100">Iniciar Sesión</button>

          <button type="button" class="btn btn-register w-100 mt-3" @click="goToRegister">
            Registrar
          </button>
        </form>

        <p v-if="errorMessage" class="text-danger mt-3 text-center">
          {{ errorMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import baseUrl from '../api';  
import { useRouter } from 'vue-router'; 
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  setup() {
    const router = useRouter(); 
    const containerRef = ref(null);
    const cardRef = ref(null);

    onMounted(() => {
      if (containerRef.value) {
        gsap.from(containerRef.value, {
          opacity: 0,
          y: 100,
          duration: 1.5,
          ease: 'power3.out'
        });
      }
      if (cardRef.value) {
        gsap.from(cardRef.value, {
          scale: 0.8,
          opacity: 0,
          delay: 0.4,
          duration: 1.2,
          ease: 'back.out(1.7)'
        });
      }
    });

    return { router, containerRef, cardRef }; 
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: ''
    };
  },
  methods: {
    async submitForm() {
      if (this.username && this.password) {
        try {
          const url = `${baseUrl}/api2/login`;
          const response = await axios.post(url, {
            email: this.username,
            password: this.password
          });

          if (response.data.success) {
            this.errorMessage = '';

            const userId = response.data.user.id_festejada;
            localStorage.setItem('id_festejada', userId);
            const paqueteUrl = `${baseUrl}/api2/paquete/${userId}`;

try {
  console.log('Consultando paquete en:', paqueteUrl); // 👈 Log para ver la URL
  const paqueteResponse = await axios.get(paqueteUrl);

  console.log('Respuesta recibida:', paqueteResponse.data); // 👈 Log para ver qué trae el backend

  if (paqueteResponse.data && paqueteResponse.data.paquete) {
    localStorage.setItem('paquete', paqueteResponse.data.paquete);
    console.log('✅ Paquete guardado en localStorage:', paqueteResponse.data.paquete); // 👈 Confirmación
  } else {
    console.warn('⚠️ No se encontró paquete en la respuesta.'); // 👈 Aviso si no trae paquete
  }

} catch (error) {
  console.error('❌ Error al consultar paquete:', error); // 👈 Log de error
  this.errorMessage = 'Hubo un error al obtener el paquete asociado.';
}


            this.router.push({ name: 'subirlista' });
          } else {
            this.errorMessage = response.data.message || 'Error desconocido en el login';
          }
        } catch {
          this.errorMessage = 'Contraseña y/o usuario incorrecto';
        }
      } else {
        this.errorMessage = 'Por favor, completa todos los campos.';
      }
    },
    goToRegister() {
      this.router.push({ name: 'Register' });
    }
  }
};
</script><style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,600;1,500&display=swap');

.log {
  background: linear-gradient(to right, #fafafa, #fdfdfd);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Playfair Display', serif;
}

.login-container {
  width: 100%;
  max-width: 380px;
  padding: 26px;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 20px;
  border: 1px solid #eee;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(8px);
  text-align: center;
}

.brand-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 500;
  color: #2e2e2e;
  margin-bottom: 0px;
  margin-top: 10px;
  letter-spacing: 1px;
}

.brand-subtitle {
  font-family: 'serenety', serif;
  font-size: 40px;
  color: #5e5a5a;
  font-style: italic;
  margin-bottom: 26px;
  margin-top: -2px;
}

.form-label {
  color: #444;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: left;
  font-size: 15px;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  margin-bottom: 14px;
  transition: border-color 0.3s ease-in-out;
}

input[type="text"]:focus,
input[type="password"]:focus {
  border-color: #aaa;
  outline: none;
  box-shadow: 0 0 0 2px rgba(200, 200, 200, 0.15);
}

.btn-login,
.btn-register {
  font-family: 'Playfair Display', serif;
  border-radius: 30px;
  padding: 12px 28px;
  font-size: 15px;
  border: none;
  transition: all 0.3s ease-in-out;
  width: 100%;
  display: inline-block;
}

.btn-login {
  background-color: #5f6770;
  color: white;
}

.btn-login:hover {
  background-color: #4c535b;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.btn-register {
  background-color: #ececec;
  color: #444;
}

.btn-register:hover {
  background-color: #e2e2e2;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
}

.text-danger {
  font-size: 13px;
  color: #d9534f;
  margin-top: 4px;
  font-family: 'Playfair Display', serif;
}
</style>
